
import BaseControlView from 'BaseControlView';
import template from 'report/control-value.ejs';
import eventBus         from 'EventBus';

//=====================================================================
//
// An instance of this view represents a value control
//
// Rene Lopez, September 2016
//
//=====================================================================
class ValueControlView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );

            this.template = template;

            this.tagName = 'div';
            this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
            this.listenTo(this.model, 'change', this.render);

            /* TODO Had to use eventBus to send to the control the property that was updated in order to render it.
               TODO Maybe something is required for merge the attributes of the Main Properties and the control views for the reports section
            */
            this.listenTo(eventBus, 'ValueControlPropertyChanged', this.render);
            return this;
        }
    
        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'ValueControlView';
        }
}

export default ValueControlView;
